import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './FlyoutSection.scss'; // TODO: make this able to be whitelabeled

var FlyoutSection = /*#__PURE__*/function (_Component) {
  _inherits(FlyoutSection, _Component);

  var _super = _createSuper(FlyoutSection);

  function FlyoutSection() {
    _classCallCheck(this, FlyoutSection);

    return _super.apply(this, arguments);
  }

  _createClass(FlyoutSection, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: styles.section
      }, /*#__PURE__*/React.createElement("header", {
        className: styles.header
      }, this.props.title), this.props.children);
    }
  }]);

  return FlyoutSection;
}(Component);

_defineProperty(FlyoutSection, "propTypes", {
  title: PropTypes.string,
  children: PropTypes.node.isRequired
});

export { FlyoutSection as default };